<template>
  <div class="mt-4">
    <div class="row">
      <div class="col-4 col-lg-3">
        <about-nav />
      </div>
      <div class="col-7 text-left">
        <h2 class="mb-4">Learn More</h2>

        <h5 class="text-muted mb-3">About CSS Gradients</h5>

        <p><a href="https://www.gradientmagic.com/blog/2019/08/08/how-to/">How to Use CSS Gradients</a></p>
        <p><a href="https://www.gradientmagic.com/blog/2019/07/27/why-gradients/">Why Use CSS Gradients?</a></p>
        <p class="mb-5"><a href="https://www.gradientmagic.com/blog/">The Blog</a></p>

        <h5 class="text-muted mb-3 mt-4">More Resources</h5>

        <p><a href="https://cssgradient.io/" target="_blank">Gradient Editor</a></p>
        <p><a href="https://gradientgenerator.com/" target="_blank">Simple Gradient Editor</a></p>
        <p class="mb-5"><a href="https://leaverou.github.io/css3patterns/" target="_blank">Cool Gradient Patterns</a></p>
      
      </div>
    </div>
  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  } 
}
</script>